"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _reactRedux = require("react-redux");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
var _numberFormatter = require("../../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var selectorArgs = {
  formName: 'advancedOrderEntry'
};
var AdvancedOrderMarketPrice = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var baseClass = _ref.baseClass;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var instrument = (0, _reactRedux.useSelector)(_instrumentPositionSelectors.selectedInstrumentSelector);
  var side = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectOrderFormValues)(state, selectorArgs).side;
  });
  var marketPrice = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectMarketPrice)(state, selectorArgs);
  });
  var formattedMarketPrice = (0, _numberFormatter.formatNumberToLocale)(marketPrice, instrument.Product2Symbol);
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass]);
  var priceTitle = side === _orderEntryFormConstants.sellValue ? t('Bid Price') : t('Ask Price ');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('limit-price-block')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('limit-price-block-label')
  }, "".concat(priceTitle, " ").concat(instrument.Product1Symbol, " (").concat(instrument.Product2Symbol, ")")), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('limit-price-block-value')
  }, formattedMarketPrice));
});
AdvancedOrderMarketPrice.displayName = 'AdvancedOrderMarketPrice';
AdvancedOrderMarketPrice.propTypes = {
  baseClass: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = AdvancedOrderMarketPrice;